import React from 'react';
import {
  ItemContainer,
  ItemContainerText,
  ItemContainerHeader,
  ItemContainerFooter,
} from '../../Item';
import SelectList from 'react-widgets/lib/SelectList';
import { Row, Col, InputGroup } from 'reactstrap';
import Indicator, { IndicatorStateOptions } from '../../Indicator';
import InformationButton from '../../Item/InformationButton';
import ErrorField from '../../../containers/Fields/ErrorField';

export interface OptionItem {
  id: string;
  display: string;
  code: string;
  data: any;
  exclusive?: boolean;
}

export type SingleSelectInputRenderProps = {
  supportingLink?: React.MouseEventHandler;
  informationText?: string[];
  indicatorState?: IndicatorStateOptions;
  text?: string;
  enabled?: boolean;
  error?: string;
  disabled?: boolean;
  name: string;
  check?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  value?: string[] | string;
  options?: OptionItem[];
};
const getValue = (value?: string | string[], options?: OptionItem[]) => {
  if (!value || !options) return undefined;

  if (Array.isArray(value)) {
    const array = options.filter(opt => value.includes(opt.code));
    return array.length !== 0 ? array : undefined;
  }
  const obj = options.find(opt => opt.code === value);
  return obj !== undefined ? [obj] : undefined;
};

const getExclusiveConfig = (
  options?: OptionItem[],
): [string | undefined, OptionItem[]] => {
  if (!options) return [undefined, []];
  const obj = options.find(opt => opt.exclusive);
  const disabledItems = options.filter(opt => !opt.exclusive);

  return [obj ? obj.code : undefined, disabledItems];
};

const MultiSelectInput = (props: SingleSelectInputRenderProps) => {
  const {
    text,
    enabled,
    supportingLink,
    informationText,
    indicatorState: state,
    options,
  } = props;
  const value = getValue(props.value, props.options);
  const exclusiveConfig = getExclusiveConfig(options);
  const isExclusive =
    exclusiveConfig[0] && value
      ? value.some(o => o.code === exclusiveConfig[0])
      : false;
  return enabled === undefined || enabled ? (
    <ItemContainer pulsing={enabled !== undefined}>
      <ItemContainerText text={text}>
        {supportingLink ? <InformationButton onClick={supportingLink} /> : null}
      </ItemContainerText>
      <ItemContainerHeader>
        <div className="d-flex flex-row-reverse justify-content-between">
          {informationText
            ? informationText.map((info, index) => (
                <div key={index} className={'d-inline-flex'}>
                  <em className={'i-information-text'}>{info}</em>
                </div>
              ))
            : null}
        </div>
      </ItemContainerHeader>
      <Row noGutters={true} className="ic-item m-2">
        <Col>
          <InputGroup>
            <SelectList
              name={props.name}
              onBlur={props.onBlur}
              onFocus={props.onFocus}
              onChange={(values?: any) => {
                return props.onChange
                  ? props.onChange(
                      values && values.length !== 0
                        ? values.map((v: any) => v.code)
                        : undefined,
                    )
                  : undefined;
              }}
              value={
                isExclusive && value
                  ? value.filter(o => o.code === exclusiveConfig[0])
                  : value
              }
              multiple
              disabled={
                props.disabled || (isExclusive ? exclusiveConfig[1] : false)
              }
              data={options}
              textField="display"
              valueField="id"
            />
          </InputGroup>
        </Col>
      </Row>
      <ItemContainerFooter>
        <div className="d-flex flex-row-reverse align-items-center ">
          <Indicator state={state} />
          <ErrorField name={props.name} />
        </div>
      </ItemContainerFooter>
    </ItemContainer>
  ) : null;
};
export default MultiSelectInput;
